import {WikiAction, WikiActionType} from './wiki.action';
import {WikiState} from './wiki.state';

export const initialWikiState: WikiState = {
  wikiList: [],
  loading: false,
  wikiItem: null,
};

export function wikiReducer(state: WikiState = initialWikiState, action: WikiAction): WikiState {
  const {type, payload} = action;

  switch (type) {
    case WikiActionType.GET_ALL:
      return {...state, loading: true};
    case WikiActionType.GET_ALL_SUCCESS:
      return {...state, loading: false, wikiList: payload.wikiList};
    case WikiActionType.CREATE_WIKI_GROUP_SUCCESS:
      return {...state, wikiList: [...state.wikiList, payload.wikiGroup]};
    case WikiActionType.UPDATE_WIKI_GROUP_SUCCESS:
      return {
        ...state,
        wikiList: state.wikiList.map(wiki => (wiki._id === payload.wikiGroup._id ? payload.wikiGroup : wiki)),
      };
    case WikiActionType.DELETE_WIKI_GROUP_SUCCESS:
      return {
        ...state,
        wikiList: state.wikiList.filter(wiki => wiki._id !== payload.id),
      };
    case WikiActionType.GET_WIKI_ITEM_SUCCESS:
      return {
        ...state,
        wikiItem: payload.wikiItem,
      };
    default:
      return state;
  }
}
